import { SVGProps, Ref, forwardRef } from 'react';

export const ViberBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M13.314 2.014C12.959 1.692 11.43.73 8.237.716c0 0-3.78-.248-5.615 1.414C1.601 3.138 1.257 4.638 1.22 6.468c-.037 1.83-.233 5.326 3.114 6.255l-.014 2.824c0 .16.025.268.116.29.066.017.164-.017.247-.1.536-.538 2.249-2.605 2.249-2.605 2.299.15 4.128-.304 4.325-.368.464-.15 2.972-.365 3.397-3.794.439-3.535-.161-5.948-1.34-6.956"
                fill="#7360F2"
            />
            <path
                d="M9.86 6.318q-.062-1.256-1.275-1.32"
                stroke="white"
                strokeWidth={0.427}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.955 6.685q.025-1.17-.693-1.955c-.48-.525-1.147-.814-2.001-.877"
                stroke="white"
                strokeWidth={0.427}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.076 7.123q-.015-2.03-1.213-3.197-1.197-1.167-2.978-1.18"
                stroke="white"
                strokeWidth={0.427}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.627 9.176s.3.025.461-.174l.315-.396c.152-.196.519-.322.878-.122q.404.23.782.5c.239.175.727.582.728.582.232.197.286.485.128.788l-.001.007a3.3 3.3 0 0 1-.656.807l-.006.005q-.338.283-.665.321a.886.886 0 0 1-.38-.038l-.008-.01c-.335-.094-.896-.331-1.83-.846a11 11 0 0 1-1.536-1.016 8 8 0 0 1-.692-.613l-.023-.023-.023-.023-.024-.024-.023-.023a8 8 0 0 1-.613-.691Q4.867 7.46 4.423 6.65c-.515-.934-.752-1.494-.846-1.83l-.01-.007a.9.9 0 0 1-.038-.38q.041-.327.322-.667l.005-.005c.232-.26.505-.482.807-.656l.006-.001c.304-.158.592-.105.788.126.002.002.408.49.582.728q.27.38.5.783c.2.359.075.726-.122.878l-.396.315c-.2.161-.174.461-.174.461s.587 2.221 2.78 2.781"
                fill="white"
            />
        </g>
    </svg>
));
ViberBrandSize16Glyph.displayName = 'ViberBrandSize16Glyph';
